import React, { useContext, useEffect } from "react";
import MsgSecundaria from "../Geral/_Aux/MsgSecundaria";
import { GlobalContext } from "../app/providers/GlobalState";
import LazyLoad from "react-lazy-load";

import { erro } from "../assets/mensagens";

const PaginaErro = () => {
    return (
        <>
            <div className="pagina-erro">
                <div className="hero" style={{ height: 620 }}>
                    <div className="container" style={{ marginTop: 60 }}>
                        <div className="pagina-erro-header">
                            <div className="container-img">
                                <img src={erro} />
                            </div>
                        </div>
                        <div className="pagina-erro-content">
                            <MsgSecundaria texto="Ocorreu um erro!" style={{ fontSize: 38 }} />
                            <MsgSecundaria texto="Tente novamente e caso o erro persista entre em contacto com o suporte." />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaginaErro;
